"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeDrawingColorCollection = void 0;
var errors_1 = require("@devexpress/utils/lib/errors");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var enums_1 = require("../color/enums");
var enums_2 = require("./enums");
var ThemeDrawingColorCollection = (function () {
    function ThemeDrawingColorCollection() {
        this.name = "";
        this.innerCollection = {};
    }
    ThemeDrawingColorCollection.prototype.tryGetDrawingColor = function (themeColorIndex) {
        return this.innerCollection[themeColorIndex];
    };
    ThemeDrawingColorCollection.prototype.setDrawingColor = function (themeColorIndex, value) {
        this.innerCollection[themeColorIndex] = value;
    };
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Light1", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Light1); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Light1, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Light2", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Light2); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Light2, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Dark1", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Dark1); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Dark1, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Dark2", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Dark2); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Dark2, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Accent1", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Accent1); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Accent1, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Accent2", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Accent2); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Accent2, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Accent3", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Accent3); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Accent3, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Accent4", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Accent4); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Accent4, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Accent5", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Accent5); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Accent5, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Accent6", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Accent6); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Accent6, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "Hyperlink", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.Hyperlink); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.Hyperlink, value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeDrawingColorCollection.prototype, "FollowedHyperlink", {
        get: function () { return this.tryGetDrawingColor(enums_1.ThemeColorIndexConstants.FollowedHyperlink); },
        set: function (value) { this.setDrawingColor(enums_1.ThemeColorIndexConstants.FollowedHyperlink, value); },
        enumerable: false,
        configurable: true
    });
    ThemeDrawingColorCollection.prototype.isValidate = function () { return this.checkValidation(); };
    ThemeDrawingColorCollection.prototype.getColorByThemeColorIndex = function (colorProvider, themeColorIndex) {
        var drawingColor = this.tryGetDrawingColor(themeColorIndex);
        if (drawingColor == null)
            throw new Error(errors_1.Errors.InternalException);
        return drawingColor.finalColor(colorProvider);
    };
    ThemeDrawingColorCollection.prototype.getColorBySchemeColorValues = function (colorProvider, value) {
        return this.getColorByThemeColorIndex(colorProvider, ThemeDrawingColorCollection.schemeColorValuesToThemeColorIndexTranslationTable[value]);
    };
    ThemeDrawingColorCollection.prototype.copyFrom = function (sourceObj) {
        this.clear();
        this.name = sourceObj.name;
        this.innerCollection = number_1.NumberMapUtils.map(sourceObj.innerCollection, function (val) { return val; });
    };
    ThemeDrawingColorCollection.prototype.clear = function () {
        this.name = "";
        number_1.NumberMapUtils.clear(this.innerCollection);
    };
    ThemeDrawingColorCollection.prototype.checkValidation = function () {
        return this.name != null &&
            number_1.NumberMapUtils.mapLength(this.innerCollection) == 12 &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Dark1] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Light1] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Dark2] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Light2] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Accent1] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Accent2] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Accent3] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Accent4] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Accent5] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Accent6] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.Hyperlink] !== undefined &&
            this.innerCollection[enums_1.ThemeColorIndexConstants.FollowedHyperlink] !== undefined;
    };
    ThemeDrawingColorCollection.schemeColorValuesToThemeColorIndexTranslationTable = (_a = {},
        _a[enums_2.SchemeColorValues.Background1] = enums_1.ThemeColorIndexConstants.Light1,
        _a[enums_2.SchemeColorValues.Background2] = enums_1.ThemeColorIndexConstants.Light2,
        _a[enums_2.SchemeColorValues.Text1] = enums_1.ThemeColorIndexConstants.Dark1,
        _a[enums_2.SchemeColorValues.Text2] = enums_1.ThemeColorIndexConstants.Dark2,
        _a[enums_2.SchemeColorValues.Light1] = enums_1.ThemeColorIndexConstants.Light1,
        _a[enums_2.SchemeColorValues.Light2] = enums_1.ThemeColorIndexConstants.Light2,
        _a[enums_2.SchemeColorValues.Dark1] = enums_1.ThemeColorIndexConstants.Dark1,
        _a[enums_2.SchemeColorValues.Dark2] = enums_1.ThemeColorIndexConstants.Dark2,
        _a[enums_2.SchemeColorValues.Accent1] = enums_1.ThemeColorIndexConstants.Accent1,
        _a[enums_2.SchemeColorValues.Accent2] = enums_1.ThemeColorIndexConstants.Accent2,
        _a[enums_2.SchemeColorValues.Accent3] = enums_1.ThemeColorIndexConstants.Accent3,
        _a[enums_2.SchemeColorValues.Accent4] = enums_1.ThemeColorIndexConstants.Accent4,
        _a[enums_2.SchemeColorValues.Accent5] = enums_1.ThemeColorIndexConstants.Accent5,
        _a[enums_2.SchemeColorValues.Accent6] = enums_1.ThemeColorIndexConstants.Accent6,
        _a[enums_2.SchemeColorValues.Hyperlink] = enums_1.ThemeColorIndexConstants.Hyperlink,
        _a[enums_2.SchemeColorValues.FollowedHyperlink] = enums_1.ThemeColorIndexConstants.FollowedHyperlink,
        _a);
    return ThemeDrawingColorCollection;
}());
exports.ThemeDrawingColorCollection = ThemeDrawingColorCollection;
